export default __webpack_public_path__ + "static/media/cardvisa-box.eea1cc93.png";